import { render, staticRenderFns } from "./Context.vue?vue&type=template&id=07ceb4e7&scoped=true"
import script from "./Context.vue?vue&type=script&lang=js"
export * from "./Context.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ceb4e7",
  null
  
)

export default component.exports